import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatUtils {

  public static titleCase(header: string): string {
    return header.replace(/((?!^)[A-Z](?![A-Z]))(?=\S)/g, ' $1').replace(/^./, s => s.toUpperCase());
  }

  public static price(value: string | number): string {
    const num = +value;
    return `$${num.toFixed(2)}`;
  }

  public static boolToYesNo(value: boolean): string {
    return value ? 'Yes' : 'No';
  }

  //Converts name formatted like 'ADAMS, JOHN' to 'John Adams'
  public static firstNameFirst(name: string): string{
    const names = name.split(', ');

    //Validate input -> for now this function only handles strings like 'ADAMS, JOHN'
    if(names.length !== 2) {return '';}

    return names[1].charAt(0) + names[1].slice(1).toLowerCase()
      + ' ' + names[0].charAt(0) + names[0].slice(1).toLowerCase();
  }
}
